import './styles.scss';

import { Col, Row } from 'react-bootstrap';

import Field from '@/common/Field';
import Modal from '@/common/Modal';
import { ReactElement } from 'react';
import SwitchInput from '@/common/SwitchInput';
import { titleCase } from '@/utils';
import { useAddonsState } from '@/features/Addons';

type AddonSettingsModalProps = {
  show: boolean;
  onHide: () => void;
};

const AddonSettingsModal = ({ show, onHide }: AddonSettingsModalProps): ReactElement => {
  const [{ settings, onSwitchColumn, onSwitchRememberFilters, onCheckAddonAsDrawer }] = useAddonsState(({ state, setState }) => [
    {
      settings: state.settings,
      onSwitchColumn: (column: keyof typeof settings.columns) => () => {
        setState((current) => ({
          ...current,
          settings: {
            ...current.settings,
            columns: {
              ...current.settings.columns,
              [column]: !current.settings.columns[column],
            },
          },
        }));
      },
      onSwitchRememberFilters: () => {
        setState((current) => ({
          ...current,
          settings: {
            ...current.settings,
            rememberFilters: !current.settings.rememberFilters,
          },
        }));
      },
      onCheckAddonAsDrawer: () => {
        setState((current) => ({
          ...current,
          settings: {
            ...current.settings,
            addonAsDrawer: !current.settings.addonAsDrawer,
          },
        }));
      },
    },
  ]);

  return (
    <Modal className="AddonSettingsModal" show={show} onHide={onHide} title="Addons Settings" centered>
      <Field label="Filters">
        <div className="AddonSettingsModal-Filters">
          <Row>
            <Col md={4}>
              <SwitchInput
                type="switch"
                id="remember-filters"
                checked={settings.rememberFilters}
                onClick={onSwitchRememberFilters}
                label="Remember Filters"
              />
            </Col>
          </Row>
        </div>
      </Field>
      <Field label="Table Columns">
        <div className="AddonSettingsModal-Columns">
          <Row>
            {Object.keys(settings.columns).map((col) => (
              <Col key={col} md={4}>
                <SwitchInput
                  type="switch"
                  id={`column-switch-${col}`}
                  checked={settings.columns[col as keyof typeof settings.columns]}
                  onClick={onSwitchColumn(col as keyof typeof settings.columns)}
                  label={titleCase(col.replace(/_/g, ' '))}
                />
              </Col>
            ))}
          </Row>
        </div>
      </Field>
      <Field label="Filters">
        <div className="AddonSettingsModal-Filters">
          <Row>
            <Col md={6}>
              <SwitchInput
                type="switch"
                onClick={onCheckAddonAsDrawer}
                checked={settings.addonAsDrawer}
                label={titleCase('Display addons as drawer')}
              />
            </Col>
          </Row>
        </div>
      </Field>
    </Modal>
  );
};

export default AddonSettingsModal;
